import { ElementRef, EventEmitter } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { bindFunctionsToThis } from '../../extensions';
import { DropDownComponent } from '../drop.down/drop.down.component';
import { FacebookLoginButtonComponent } from '../facebook.login.button/facebook.login.button.component';
import { GoogleLoginButtonComponent } from '../google.login.button/google.login.button.component';
var SocialLoginPopupComponent = /** @class */ (function () {
    function SocialLoginPopupComponent(imageService) {
        this.imageService = imageService;
        this.isLoggedIn = false;
        this.img = '';
        this.fbLogo = config.fbLogo;
        this.googleLogo = config.googleLogo;
        this.text = '';
        this.onLoginStatusChanged = new EventEmitter();
        this.onDropdownShow = new EventEmitter();
        bindFunctionsToThis(this);
        this.fbLogo = this.imageService.imageSourceUrl(this.fbLogo);
        this.googleLogo = this.imageService.imageSourceUrl(this.googleLogo);
        // setTimeout(() => {
        //     if (this.isUserLoggedIn) {
        //         this.loginStatusChanged(true);
        //     }
        // }, 3000);
    }
    Object.defineProperty(SocialLoginPopupComponent, "isUserLoggedIn", {
        get: function () {
            return GoogleLoginButtonComponent.isUserLoggedWithGoogle || FacebookLoginButtonComponent.isUserLoggedWithFacebook;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SocialLoginPopupComponent, "userId", {
        get: function () {
            if (GoogleLoginButtonComponent.isUserLoggedWithGoogle) {
                return GoogleLoginButtonComponent.googleUserId + '|google';
            }
            if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
                return FacebookLoginButtonComponent.authResponse.authResponse.userID;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SocialLoginPopupComponent, "profilePicture", {
        get: function () {
            if (GoogleLoginButtonComponent.isUserLoggedWithGoogle) {
                return GoogleLoginButtonComponent.profilePicture;
            }
            if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
                return FacebookLoginButtonComponent.profilePicture;
            }
        },
        enumerable: true,
        configurable: true
    });
    SocialLoginPopupComponent.prototype.logout = function () {
        var _this = this;
        if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            this.fbLoginBtn.logout();
            // Facebook logout has problems on non-production env (because of the domain cannot be added in the App settings)
            this.onLoginStatusChanged.emit({ status: false, profileImg: null });
        }
        if (GoogleLoginButtonComponent.isUserLoggedWithGoogle) {
            this.googleLoginBtn.logout();
        }
        this.isLoggedIn = false;
        setTimeout(function () {
            _this.wrap.nativeElement.style.display = 'block';
            _this.profileImg.nativeElement.style.display = 'none';
            if (_this.fbLoginBtn.profileImg) {
                _this.fbLoginBtn.profileImg.nativeElement.style.display = 'none';
            }
        }, 1000);
    };
    SocialLoginPopupComponent.prototype.loginStatusChanged = function ($event) {
        var _this = this;
        if ($event) {
            this.isLoggedIn = true;
            setTimeout(function () {
                _this.wrap.nativeElement.style.display = 'none';
                _this.profileImg.nativeElement.style.display = 'block';
                _this.profileImg.nativeElement.src = SocialLoginPopupComponent.profilePicture;
            });
        }
        this.onLoginStatusChanged.emit({ status: $event, profileImg: SocialLoginPopupComponent.profilePicture });
    };
    SocialLoginPopupComponent.prototype.dropdownShow = function () {
        this.onDropdownShow.emit();
    };
    return SocialLoginPopupComponent;
}());
export { SocialLoginPopupComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/social.login.popup/social.login.popup.component.ts.pre-build-optimizer.js